import './OfferAndDeal.css';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import TruncateMarkup from 'react-truncate-markup';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import { ReactComponent as Star } from '../../../resources/icons/star-v1.svg';
import { ReactComponent as World } from '../../../resources/icons/icon-world.svg';
import { ReactComponent as Email } from '../../../resources/icons/@-v1.svg';
import { ReactComponent as Phone } from '../../../resources/icons/icon-phone.svg';
import { ReactComponent as Share } from '../../../resources/icons/icon-share-v1.svg';
import { ReactComponent as ArrowRight } from '../../../resources/icons/icon-chevron-right-v1.svg';
import { ReactComponent as ArrowLeft } from '../../../resources/icons/icon-chevron-left-v1.svg';
import bluePlusImg from '../../../resources/icons/blue-plus.svg';
import blueMinusImg from '../../../resources/icons/blue-minus.svg';
import { getColorByTheme, getPageThemeColors, hexToRgb, pathJoin, getMediaHost, injectImageResolution, get, getGlobalDictionaryTerm, canUseDOM } from '../../../utils';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { isNotNil } from '../../../utils/IsNil';
import { HighlighterHOC } from '../../atoms/HighlighterHOC/HighlighterHOC';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { useSitecoreContext } from '../../../utils/hooks/UseSitecoreContext';
import { BlurCard, EBlurCardImageTypes, isShowRuleIsHide } from '../../atoms/BlurCard/BlurCard';
import { HighlighterWithRichtextHOC } from '../../atoms/HighlighterWithRichtextHOC/HighlighterWithRichtextHOC';
const commonStyles = "c1chm07b";
const ltrStyles = "l193l1jx";
const rtlStyles = "r1ood5x9";
const socialIconsSize = {
  facebook: {
    width: '23px',
    height: '23px'
  },
  email: {
    width: '31px',
    height: '22px'
  },
  twitter: {
    width: '23px',
    height: '23px'
  },
  whatsapp: {
    width: '25px',
    height: '25px'
  }
};
const DealAndOffer = _ref => {
  let {
    deal,
    rtl,
    fromText,
    offText,
    currency,
    currencyIndex,
    expiresSoonText,
    moreInfoText,
    bookNowText,
    readMoreText,
    readLessText,
    termsAndConditionsText,
    gridMode,
    socialSharing,
    useTruncate = true,
    callback,
    textToHighlight,
    themeVariables,
    eventsAnalytics,
    params,
    ratingTextStar,
    ratingTextStars,
    isSwipeable = true,
    isDraggable = true,
    countryItems,
    userProfile
  } = _ref;
  const detailsRef = useRef(null);
  const sitecoreContext = useSitecoreContext();
  const lang = sitecoreContext && sitecoreContext.language || 'en';
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const nextArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'nextArrowLabel') || 'Next slide';
  const prevArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'prevArrowLabel') || 'Previous slide';
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const socialSharingTitlte = get(socialSharing, 'title.jss.value');
  const likeButtonsTitle = encodeURIComponent(get(socialSharing, 'likeButtonsTitle.jss.value'));
  const socialLinks = socialSharing ? get(socialSharing, 'socialLinks.values') : [];
  const BASE_URL = String(process.env.STORYBOOK_MODE ? 'https://cmqa.testvisitdubai.com/' : process.env.REACT_APP_MEDIA_HOST || '');
  const mediaAssets = get(deal, 'mediaAssets.urls', []);
  const [visibleDetail, setVisibleDetail] = useState(false);
  const [visibleSharings, setVisibleSharings] = useState(false);
  const [truncateWidth, setTruncateWidth] = useState(1100);
  const [isTruncated, setisTruncated] = useState(true);
  const [termsVisible, setTermsVisible] = useState(false);
  const [isVdsite, setIsVdsite] = useState(true);
  const colorSettings = useMemo(() => {
    if (themeVariables) {
      const values = Object.values(themeVariables);
      return {
        '--component-background-color': values[0],
        '--component-background-color-rgb': values[1],
        '--component-background-active-color': values[2],
        '--component-color': values[3]
      };
    }
    return {
      '--component-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
      '--component-background-color-rgb': hexToRgb(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary, true),
      '--component-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
      '--component-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
    };
  }, [themeVariables, isVdsite, primaryPageThemeColor, primaryActivePageThemeColor]);
  const showPrice = useMemo(() => !!(Number(deal.price) || Number(deal.discount)), [deal]);
  const renderPriceSticker = () => {
    if (!showPrice) {
      return null;
    }
    if (Number(deal.discount)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "from-text"
      }, "\xA0"), /*#__PURE__*/React.createElement("div", {
        className: "main-price"
      }, deal.discount, "%"), /*#__PURE__*/React.createElement("div", {
        className: "currency"
      }, offText));
    }

    /* const oldPrice: number | null = currencyIndex ? deal.price.replace(/,/g, '') * currencyIndex : null; */
    const oldPrice = currencyIndex ? deal.price * currencyIndex : deal.price;
    if (Number(deal.discountedPrice)) {
      /* const finalPrice: number | null = currencyIndex ? deal.discountedPrice.replace(/,/g, '') * currencyIndex : null; */
      const finalPrice = currencyIndex ? deal.discountedPrice * currencyIndex : deal.discountedPrice;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "from-text from-text--crossed"
      }, oldPrice && Math.round(oldPrice)), /*#__PURE__*/React.createElement("div", {
        className: "main-price"
      }, finalPrice && Math.round(finalPrice)), /*#__PURE__*/React.createElement("div", {
        className: "currency"
      }, currency));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "from-text"
    }, fromText), /*#__PURE__*/React.createElement("div", {
      className: "main-price"
    }, Math.round(oldPrice)), /*#__PURE__*/React.createElement("div", {
      className: "currency"
    }, currency));
  };
  const renderTags = () => {
    const dayLength = 24 * 60 * 60 * 1000;
    let expiresSoon = false;
    if (deal.expirySoon_s) {
      const daysToExpire = Math.round((deal.expirySoon_s * 1000 - Date.now()) / dayLength);
      expiresSoon = daysToExpire < 3 && daysToExpire >= 0;
    }
    if (!deal.bestSeller && !expiresSoon) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "deal__image-tags"
    }, deal.bestSeller && /*#__PURE__*/React.createElement("div", {
      className: "deal__image-tag deal__image-tag--blue"
    }, deal.bestSeller), expiresSoon && /*#__PURE__*/React.createElement("div", {
      className: "deal__image-tag deal__image-tag--red"
    }, expiresSoonText));
  };
  const renderRating = () => {
    const ratingText = deal.hotelStars && deal.hotelStars > 1 ? `${deal.hotelStars} ${ratingTextStars}`.toUpperCase() : `${Star} 1 ${ratingTextStar}`.toUpperCase();
    return /*#__PURE__*/React.createElement("div", {
      className: "deal__rating"
    }, deal.hotelStars && /*#__PURE__*/React.createElement(Star, null), /*#__PURE__*/React.createElement("span", {
      className: "ratingText"
    }, deal.hotelStars ? ratingText : " "), deal.hotelStars && /*#__PURE__*/React.createElement("div", {
      className: "renderRating-dots"
    }));
  };
  const renderTopContacts = () => /*#__PURE__*/React.createElement("div", {
    className: "deal__details-top-contacts"
  }, (deal.website || deal.listingvendorswebsite) && /*#__PURE__*/React.createElement("a", {
    href: deal.website || deal.listingvendorswebsite,
    "aria-label": "website",
    "aria-labelledby": "website",
    className: "deal__details-top-contact-item"
  }, /*#__PURE__*/React.createElement(World, null), deal.website));
  const renderContacts = () => /*#__PURE__*/React.createElement("div", {
    className: "deal__details-contacts"
  }, deal.phone && /*#__PURE__*/React.createElement("a", {
    href: `tel:${deal.phone}`,
    "aria-label": "Phone",
    className: "deal__details-contact-item",
    "aria-labelledby": "Phone"
  }, /*#__PURE__*/React.createElement(Phone, null)), (deal.email || deal.offersdealsemail) && /*#__PURE__*/React.createElement("a", {
    href: `mailto:${deal.email || deal.offersdealsemail}`,
    "aria-label": "email",
    "aria-labelledby": "Email",
    className: "deal__details-contact-item"
  }, /*#__PURE__*/React.createElement(Email, null)), (deal.website || deal.listingvendorswebsite) && /*#__PURE__*/React.createElement("a", {
    href: deal.website || deal.listingvendorswebsite,
    "aria-label": "website",
    "aria-labelledby": "website",
    className: "deal__details-contact-item"
  }, /*#__PURE__*/React.createElement(World, null)));
  const renderShares = function () {
    let visiblityMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tileView';
    let itemTitle = arguments.length > 1 ? arguments[1] : undefined;
    return socialLinks.map(item => {
      const icon = get(item, 'icon.jss.value.src');
      const iconAlt = get(item, 'icon.jss.value.alt');
      let link = get(item, 'link.jss.value', '');
      const svgIcon = get(item, 'svgIcon.jss.value');
      const nameSocial = get(item, 'name');
      const getLinkStyle = () => {
        for (let key in socialIconsSize) {
          if (nameSocial.toLowerCase().includes(key)) {
            return socialIconsSize[key];
          }
        }
        return {};
      };
      if (link) if (nameSocial.toLowerCase().includes('linkedin')) {
        link = link.replace('title=', 'title%3D');
      }
      link = link.replace(`\${message}`, likeButtonsTitle).replace(`\${link}`, deal.url);
      return /*#__PURE__*/React.createElement("a", {
        key: `${visiblityMode}-${link}`,
        rel: "noreferrer noopener",
        href: link,
        target: "_blank",
        className: "deal__details-contact-item--share",
        title: nameSocial ? `${nameSocial} | ${newWindowLabel}` : newWindowLabel,
        onKeyPress: event => {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            event.preventDefault();
            event.target.click();
          }
        },
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToShareAnalytics'], params), [itemTitle, nameSocial]);
        }
      }, svgIcon ? /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: svgIcon
        }
      }) : /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        className: nameSocial
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: BASE_URL + icon
      }), /*#__PURE__*/React.createElement("img", {
        className: "social-sharing__icon",
        src: BASE_URL + icon,
        alt: iconAlt,
        title: iconAlt,
        style: getLinkStyle()
      })));
    });
  };
  useEffect(() => {
    if (canUseDOM) {
      if (!document.body.classList.contains('vdsite')) {
        setIsVdsite(false);
      }
    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      if (detailsRef.current && !gridMode) {
        setTruncateWidth(detailsRef.current.offsetWidth);
      }
    }, 100);
  }, [gridMode]);
  const ButtonGroup = props => {
    const {
      carouselState: {
        currentSlide,
        totalItems
      },
      goToSlide
    } = props;
    if (totalItems > 1) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "navigation-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: `my-icon-white carousel-icon carousel-icon-left ${currentSlide === 0 ? 'carousel-icon--inactive' : ''}`,
        disabled: currentSlide === 0,
        onClick: () => {
          props.previous();
        },
        "aria-label": prevArrowLabel,
        title: prevArrowLabel
      }, /*#__PURE__*/React.createElement(ArrowLeft, null)), /*#__PURE__*/React.createElement("button", {
        className: `my-icon-white carousel-icon carousel-icon-right ${currentSlide >= totalItems - 1 ? 'carousel-icon--inactive' : ''}`,
        disabled: currentSlide >= totalItems - 1,
        onClick: () => {
          props.next();
        },
        "aria-label": nextArrowLabel,
        title: nextArrowLabel
      }, /*#__PURE__*/React.createElement(ArrowRight, null))), /*#__PURE__*/React.createElement("div", {
        className: "dot-container"
      }, Array.from(Array(totalItems).keys()).map(index => /*#__PURE__*/React.createElement("div", {
        tabIndex: currentSlide === index ? -1 : 0,
        key: index,
        className: `dot ${currentSlide === index ? 'dot--active' : ''}`,
        onClick: () => {
          goToSlide(index);
        }
      }))));
    }
    return null;
  };
  const bookLinkText = isNotNil(deal.bookLinkText) && deal.bookLinkText !== "" ? deal.bookLinkText : bookNowText;
  const analyticTermAndConditionClick = textArray => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['termAndConditionAnalytics'], params), textArray);
  };
  const toggleTermAndConditions = () => {
    setTermsVisible(!termsVisible);
    analyticTermAndConditionClick([!termsVisible ? "expand" : "collapse", deal.englishTitle]);
  };
  return isShowRuleIsHide(deal) ? /*#__PURE__*/React.createElement(BlurCard, {
    userProfile: userProfile,
    hint: deal,
    lang: lang,
    cardType: EBlurCardImageTypes.deals,
    hitAnalytics: eventsAnalytics,
    hitParams: params,
    reminderTheme: [Object.values(colorSettings)[0], Object.values(colorSettings)[3]],
    countryItems: countryItems
  }) : /*#__PURE__*/React.createElement("div", {
    style: colorSettings,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${deal.featured ? 'deal--featured' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__image-container-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `deal__image-container ${showPrice ? 'deal__image-container--priced' : ''}`,
    onClick: () => {}
  }, mediaAssets.length ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref2 => {
    let {
      renderCarousel
    } = _ref2;
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderCarousel(mediaAssets.map(image => {
      const deskImg = injectImageResolution(pathJoin([getMediaHost(), image]), 580, 420);
      const mobImg = injectImageResolution(pathJoin([getMediaHost(), image]), 325, 212);
      return /*#__PURE__*/React.createElement(LazyPicture, {
        useEmptyPlaceholder: true,
        hover: true,
        key: deskImg
      }, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 992px)",
        srcSet: deskImg
      }), /*#__PURE__*/React.createElement("img", {
        className: "deal__image",
        src: mobImg,
        alt: deal.title
      }));
    }), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        }
      },
      customButtonGroup: /*#__PURE__*/React.createElement(ButtonGroup, null),
      containerClass: 'dealAndOfferCarouselContainer',
      swipeable: isSwipeable,
      draggable: isDraggable
    }));
  }) : /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: injectImageResolution(pathJoin([getMediaHost(), '']), 580, 420)
  }), /*#__PURE__*/React.createElement("img", {
    className: "deal__image",
    src: injectImageResolution(pathJoin([getMediaHost(), '']), 325, 212),
    alt: deal.title
  })), /*#__PURE__*/React.createElement("div", {
    className: "deal__image-price-sticker"
  }, renderPriceSticker()), renderTags()), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: deal.objectID,
    callback: callback,
    analyticsClick: titleForButton => {
      if (~titleForButton.toLowerCase().indexOf('add')) {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToFavoriteAnalytics'], params), deal.englishTitle);
      }
      if (~titleForButton.toLowerCase().indexOf('remove')) {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToRemoveFavoriteAnalytics'], params), deal.englishTitle);
      }
    },
    classes: "deal__image__fav-btn"
  })), /*#__PURE__*/React.createElement("div", {
    className: "deal__info-container"
  }, renderRating(), /*#__PURE__*/React.createElement("div", {
    className: "deal__header-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    tabIndex: 0,
    onClick: () => {
      setVisibleDetail(!visibleDetail);
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToTitleAnalytics'], params), deal.englishTitle);
    },
    className: "deal__header deal__header--interactive"
  }, /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: deal.title,
    searchString: textToHighlight
  })), /*#__PURE__*/React.createElement("h3", {
    className: "deal__header"
  }, /*#__PURE__*/React.createElement(HighlighterHOC, {
    text: deal.title,
    searchString: textToHighlight
  })), /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setVisibleDetail(!visibleDetail);
      !visibleDetail && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToExpandAnalytics'], params), deal.englishTitle);
    },
    className: "deal__header-btn"
  }, /*#__PURE__*/React.createElement("img", {
    className: "deal__header-btn-icon",
    src: visibleDetail ? blueMinusImg : bluePlusImg,
    alt: moreInfoText
  }))), renderTopContacts(), showPrice && /*#__PURE__*/React.createElement("div", {
    className: "deal__info-price-sticker"
  }, renderPriceSticker()), /*#__PURE__*/React.createElement("div", {
    className: `deal__details ${visibleDetail ? 'deal__details--visible' : ''}`
  }, moreInfoText && /*#__PURE__*/React.createElement("h6", {
    className: "deal__details-header"
  }, moreInfoText), /*#__PURE__*/React.createElement("div", {
    className: "deal__details-main"
  }, /*#__PURE__*/React.createElement(HighlighterWithRichtextHOC, {
    richText: deal.info || deal.introText,
    searchWords: textToHighlight || ''
  })), deal.termsAndConditions && /*#__PURE__*/React.createElement("div", {
    className: "deal__details-terms"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__details-terms-link"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: toggleTermAndConditions
  }, termsAndConditionsText, /*#__PURE__*/React.createElement("img", {
    className: "deal__details-terms-link-icon",
    src: termsVisible ? blueMinusImg : bluePlusImg,
    alt: termsAndConditionsText
  }))), termsVisible && /*#__PURE__*/React.createElement("div", {
    className: "deal__details-terms-content",
    dangerouslySetInnerHTML: {
      __html: deal.termsAndConditions
    }
  })), renderContacts()), /*#__PURE__*/React.createElement("div", {
    ref: detailsRef,
    className: "deal__details-list-veiw-main"
  }, /*#__PURE__*/React.createElement("div", {
    style: useTruncate ? {
      width: `${truncateWidth}px`
    } : {}
  }, useTruncate && isTruncated ? /*#__PURE__*/React.createElement("div", {
    className: "truncated-copy"
  }, /*#__PURE__*/React.createElement(TruncateMarkup, {
    lines: 2,
    ellipsis: /*#__PURE__*/React.createElement("span", null, `... `, /*#__PURE__*/React.createElement("button", {
      onClick: () => {
        setisTruncated(false);
      },
      className: "btn btn-link"
    }, readMoreText))
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: deal.info || deal.introText
    }
  }), deal.termsAndConditions && /*#__PURE__*/React.createElement("div", {
    className: "deal__details-list-veiw-terms"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__details-list-veiw-terms-link"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: () => {
      setTermsVisible(!termsVisible);
    }
  }, termsAndConditionsText, /*#__PURE__*/React.createElement("img", {
    className: "deal__details-terms-link-icon",
    src: termsVisible ? blueMinusImg : bluePlusImg,
    alt: termsAndConditionsText
  }))), termsVisible && /*#__PURE__*/React.createElement("div", {
    className: "deal__details-terms-content",
    dangerouslySetInnerHTML: {
      __html: deal.termsAndConditions
    }
  }))))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HighlighterWithRichtextHOC, {
    richText: deal.info || deal.introText,
    searchWords: textToHighlight || ''
  }), deal.termsAndConditions && /*#__PURE__*/React.createElement("div", {
    className: `${useTruncate ? '' : 'mb-2 '}deal__details-list-veiw-terms`
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__details-list-veiw-terms-link"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: () => {
      setTermsVisible(!termsVisible);
    }
  }, termsAndConditionsText, /*#__PURE__*/React.createElement("img", {
    className: "deal__details-terms-link-icon",
    src: termsVisible ? blueMinusImg : bluePlusImg,
    alt: termsAndConditionsText
  }))), termsVisible && /*#__PURE__*/React.createElement("div", {
    className: "deal__details-terms-content",
    dangerouslySetInnerHTML: {
      __html: deal.termsAndConditions
    }
  })), useTruncate && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      setisTruncated(true);
    },
    className: "btn btn-link"
  }, readLessText))))), /*#__PURE__*/React.createElement("div", {
    className: "deal__actions-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__actions-book-wrapper"
  }, deal.bookLink && /*#__PURE__*/React.createElement("div", {
    className: "deal__actions-book"
  }, /*#__PURE__*/React.createElement("a", {
    href: deal.bookLink,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['callToBookAnalytics'], params), deal.englishTitle);
    },
    className: "btn btn-primary deal__actions-book-btn",
    "aria-label": "Book Link",
    "aria-labelledby": "Book Link"
  }, bookLinkText)), /*#__PURE__*/React.createElement("div", {
    className: "deal__details-list-veiw-contacts"
  }, renderContacts())), socialSharing && /*#__PURE__*/React.createElement("div", {
    className: "deal__actions-share-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": socialSharingTitlte,
    onClick: () => {
      setVisibleSharings(!visibleSharings);
    },
    className: `deal__actions-share ${visibleSharings ? 'deal__actions-share--active' : ''}`
  }, /*#__PURE__*/React.createElement(Share, null)), /*#__PURE__*/React.createElement("div", {
    className: `deal__share-panel-list-veiw-medias ${visibleSharings ? 'deal__share-panel-list-veiw-medias--visible' : ''}`
  }, renderShares('listView', deal.englishTitle)))), socialSharing && /*#__PURE__*/React.createElement("div", {
    className: `deal__share-panel-wrapper ${visibleSharings ? 'deal__share-panel-wrapper--visible' : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "deal__share-panel-header"
  }, socialSharingTitlte), /*#__PURE__*/React.createElement("div", {
    className: "deal__share-panel-medias"
  }, renderShares('tileView', deal.englishTitle)))));
};
export default DealAndOffer;